module.exports = __webpack_public_path__ + "img/emoji_98.6ce1cfce.png";